var $ce0bee578e53860c$exports = {};
$ce0bee578e53860c$exports = {
    "longPressMessage": `\u{957F}\u{6309}\u{6216}\u{6309} Alt + \u{5411}\u{4E0B}\u{65B9}\u{5411}\u{952E}\u{4EE5}\u{6253}\u{5F00}\u{83DC}\u{5355}`
};


export {$ce0bee578e53860c$exports as default};
//# sourceMappingURL=zh-CN.mjs.map
